import React from 'react';
import Button from '../../components/ui/Button';
import Link from '../../components/ui/Link';
import { useTranslation } from 'react-i18next';

const TrendingProducts = () => {

  const {t} = useTranslation();

  const trendingProducts = [
    {
      id: 1,
      title: "",
      description: "",
      price: "₹2999",
      image: "/images/img_4_org_zoom_1.png",
      hasNewBadge: true
    },
    {
      id: 2,
      title: "",
      description: "",
      price: "₹2999",
      image: "/images/img_4_org_zoom_1_344x406.png",
      hasNewBadge: false
    },
    {
      id: 3,
      title: "",
      description: "",
      price: "₹4999",
      image: "/images/img_4_org_zoom_1_1.png",
      hasNewBadge: true
    }
  ];

  return (
    <section className="w-full py-8 lg:py-16">
      <div className="w-full max-w-[1262px] mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-8 lg:mb-10">
          <h2 className="text-2xl lg:text-4xl font-medium text-black">{t("trending_must")}</h2>
       
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-5">
          {trendingProducts?.map((product) => (
            <div
              key={product?.id}
              className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow"
            >
              {/* Product Image Container */}
              <div className="relative bg-white">
           
                <img
                  src={product?.image}
                  alt={product?.title}
                  className="w-full h-[250px] lg:h-[344px] object-cover rounded-t-lg"
                  loading="lazy"
                />
              </div>

              {/* Product Details */}
              <div className="bg-[#262626] text-white p-4">
                <div className="flex justify-between items-start gap-4">
                  <div className="flex-1">
                    <h3 className="text-base font-semibold text-white mb-3">
                      {product?.title}
                    </h3>
                    <p className="text-sm text-[#c4c4c4d8] mb-4">
                      {product?.description}
                    </p>
                  </div>
                  <div className="flex items-center gap-2 border border-[#d9d9d9] rounded-lg px-2 py-2">
               
                    <span className="text-sm font-semibold text-white">
                      {t("footerSections.shop_now")}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrendingProducts;